namespace advisorop.domains {

    export interface IUser {
        id?: string;
        username?: string;
        firstName?: string;
        lastName?: string;
        email?: string;
        role?: string;
    }

    //servicer CRUD model
    export interface IServicer extends IUser {
        // System login state, read-only on the servicer edit screen: it is changed by the
        // lifecycle actions on the servicer list, not by saving this form.
        fullName?: string;
        loginStatus?: number;
        loginStatusDesc?: string;
        systemLoginTypeDesc?: string;
        twoFactorEnabled?: boolean;

        /// See advisorop.identity.SsoModeOption.
        ssoMode?: number;
        lastLogin?: Date;
    }
    
    export class Servicer implements IServicer {
        public firstName: string;
        public lastName: string;
        public username: string;        
        public email: string;
        public role: string;
    }

    //create servicer view model
    export interface IServicerCreate extends IServicer {
    }

    export class ServicerCreate extends Servicer implements IServicerCreate {
    }

    export interface ISleeveModelRec {
        asOfDate: Date;
        accountId: number;
        custodianAccountId: number;
        number: string;
        modelIdentifierInt: number;
        managerProductId: number;
        actualPercentage: number;
        actualPercentagePrime: number;
        proposalPercentage: number;
        modelValue: number;
        accountTotal: number;
        accountTotalPrime: number;
        cash: number;
        accountCash: number;
        accountCashPrime: number;
        result: number;
        accountName: string;
        productName: string;
        firmName: string;
    }

    export class SleeveModelRec implements ISleeveModelRec {
        public asOfDate: Date;
        public accountId: number;
        public custodianAccountId: number;
        public number: string;
        public modelIdentifierInt: number;
        public managerProductId: number;
        public actualPercentage: number;
        public actualPercentagePrime: number;
        public proposalPercentage: number;
        public modelValue: number;
        public accountTotal: number;
        public accountTotalPrime: number;
        public cash: number;
        public accountCash: number;
        public accountCashPrime: number;
        public result: number;
        public accountName: string;
        public productName: string;
        public firmName: string;
    }
}
